import { render, staticRenderFns } from "./ResearchScorePlot.vue?vue&type=template&id=955ec600"
import script from "./ResearchScorePlot.vue?vue&type=script&lang=js"
export * from "./ResearchScorePlot.vue?vue&type=script&lang=js"
import style0 from "./ResearchScorePlot.vue?vue&type=style&index=0&id=955ec600&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Adipose Gateway - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('955ec600')) {
      api.createRecord('955ec600', component.options)
    } else {
      api.reload('955ec600', component.options)
    }
    module.hot.accept("./ResearchScorePlot.vue?vue&type=template&id=955ec600", function () {
      api.rerender('955ec600', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/ResearchScorePlot.vue"
export default component.exports